import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Goutom Roy </span>
            from <span className="purple"> Dhaka, Bangladesh.</span>
            <br />
            I work as a Mobile App Developer at <a className="purple" href="https://symphonysofttech.com/" style={{ textDecoration: 'none' }} >Symphony SoftTech Ltd</a>.
            <br />
            I completed my Bachelor's in Computer Science & Engineering from <i>Daffodil International University</i> ,Dhaka.
            <br />
            <br />
            When I'm not writing code, you’ll probably find me doing one of these:
          </p>

          <ul>
            <li className="about-activity">
              🎮 Gaming like a pro</li>
            <li className="about-activity">✈️ Exploring new places</li>
            <li className="about-activity">🌿 Getting my hands dirty in the garden</li>
          </ul>


          <i><p style={{ color: "rgb(155 126 172)" }}>
            “It always seems impossible until it’s done.”
          </p></i>
          <footer className="blockquote-footer">Nelson Mandela</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
